import { useEffect } from "react"

export const useNextJsScrollRestoration = () => {
    useEffect(() => {
        // Ensure scroll restoration is only set on the client side
        if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
            window.history.scrollRestoration = "auto"
        }
        return () => {
            if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
                window.history.scrollRestoration = "manual"
            }
        }
    }, [])
}
